module.exports = __webpack_public_path__ + "files/SPIADI2026 - NÉO INF ADI - Guide Technique.f3d8189e221cfde47f4e37a30734762e.pdf";